/* unplugin-vue-components disabled */import { render } from "./BaseForm.vue?vue&type=template&id=45fc2c6d&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=45fc2c6d&lang=stylus&scoped=true"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fc2c6d"]])

export default __exports__